module.exports = __webpack_public_path__ + "static/media/TigoSportsHeaderImg.29a73a6d.png";